import { useMemo, useState } from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { useGetFacilityById } from "../../api/facility";
import { useGetCountries } from "../../api/static-data";
import FacilityDetailsModal from "./facilityDetails/FacilityDetailsModal";
import FacilityEditModal from "./facilityEdit/FacilityEditModal";
import { FACILITY_TYPES } from "../../config/constants";

const ManageFacilityData = ({
  facilityId,
  closeManager
}: {
  facilityId: string;
  closeManager: () => void;
}) => {
  const [visibleEditModal, setVisibleEditModal] = useState<boolean>(false);
  const [visibleDetailsModal, setVisibleDetailsModal] = useState<boolean>(true);

  const { data: countriesData, isLoading: isCountriesDataLoading } = useGetCountries();
  const {
    data: facilityData,
    isFetching: isFacilityLoading,
  } = useGetFacilityById(facilityId);

  const enableEditFacility = () => {
    setVisibleDetailsModal(false);
    setVisibleEditModal(true);
  };
  
  const facilityTypeValue = facilityData?.facilityType;

  const facilityDataWithFacilityType = useMemo(() => {
    const facilityType = FACILITY_TYPES.find(
      type => type.value === facilityTypeValue
    ) || { text: facilityTypeValue, value: facilityTypeValue }
    return {
      ...facilityData,
      facilityType: facilityType.text
    };
  }, [facilityData, facilityTypeValue]);

  if (isCountriesDataLoading || isFacilityLoading) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }
  return (
    <>
      <FacilityEditModal
        visibleModal={visibleEditModal}
        setVisibleModal={() => {
          setVisibleEditModal(false);
          closeManager();
        }}
        facilityData={facilityData}
      />
      <FacilityDetailsModal
        visibleModal={visibleDetailsModal}
        setVisibleModal={() => {
          setVisibleDetailsModal(false);
          closeManager();
        }}
        facilityData={facilityDataWithFacilityType}
        countries={countriesData}
        setVisibleEdit={enableEditFacility}
      />
    </>
  );
};

export default ManageFacilityData;
